$(function() {
  $.localeSwitcher('#locale');

  // fake interaction for invite link
  $('.better_panel a').one('click', function(e) {
    e.preventDefault();
    $(this).prepend("<span class='icon icon_tick'></span>");
    return false;
  });

  // Responsive menu toggler
  var $menus = $('.header nav, .ssn_lnks, #locale_form');
  $('#tgl_mnu').click(function(e) {
    e.preventDefault();
    $menus.toggle();
    return false;
  });

  // See more button for landing pages
  var $see_more = $('#see_more');
  $see_more.one('click', function(e) {
    e.preventDefault();
    $.ajax({
      url: this.href,
      dataType: 'html',
      beforeSend: function() {
        $see_more.addClass('active');
      },
      complete: function() {
        $see_more.removeClass('active');
      },
      success: function(data) {
        $('#ldg').after(data);
        $see_more.remove();
      },
    });
    return false;
  });
});
